import React, { } from 'react';
import { IAliTableCellComponentProps } from "@customComp/AliTableAnalytics/types";
import { getCellText } from '@customComp/AliTableAnalytics/utils';
import SvgIcon from '@home/components/SvgIcon';
import { isEmptyValue } from '@home/utils/common';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

/**
 * MetricUpDown 组件，用于显示带有上下箭头的指标变化百分比
 * @param props - 组件属性
 * @param props.value - 指标值，可以是任意类型
 */
export const MetricUpDown = (props: { value: any; }) => {
  // 从props中解构value值，如果props为空则使用空对象
  const { value: oValue } = props || {};
  // 检查值是否为空或为NaN，如果是则返回'-'
  if (isEmptyValue(oValue)) return '-';
  // 将值转换为数字类型
  const value = Number(oValue);
  if (isNaN(value)) return '-';
  // 极限值限制
  const clamped = Math.max(-999.99, Math.min(999.99, value));
  const updown = clamped > 0 ? 'up' : 'down';
  // 计算符号
  const sign = clamped === 0 ? 'zero' : updown;
  // 计算文本
  const text = dataFormat({ value: Math.abs(clamped), formatRule: { type: 'decimals', decimal: 2 } });
  const svgTypeObj = {
    up: 'green-up-new',
    down: 'red-down-new',
    zero: 'zero'
  };
  // 计算箭头
  const type = svgTypeObj[sign];
  return <span className={`dbl-table-compare-cell-value-${sign}`}>{`${text}%`} <SvgIcon type={type} /></span>;
};

// 对比日期下日期单元格
export const CompareDateCell: React.FC<IAliTableCellComponentProps> = (props) => {
  const { row, column } = props || {};
  const { value, compare_value: compareValue } = row?.[column?.code] || {};

  return (<div className='dbl-table-compare-cell'>
    <div className='dbl-table-compare-cell-value'>{value || '-'}</div>
    <div className='dbl-table-compare-cell-value dbl-table-compare-cell-value-contrast'>{compareValue}</div>
  </div>);
};

// 日期对比下指标单元格（一行展示三个数值：基准时间-指标值、对比时间-指标值、环比值）
export const CompareMetricCell: React.FC<IAliTableCellComponentProps> = (props) => {
  const { row, column } = props || {};
  const { value, compare_value: compareValue, change, is_statistics: isStatistics } = row?.[column?.code] || {};

  return (
    <div className='dbl-table-compare-cell'>
      <div className='dbl-table-compare-cell-value'>{getCellText(value, column) || '-'}</div>
      <div className='dbl-table-compare-cell-value dbl-table-compare-cell-value-contrast'>{getCellText(compareValue, column) || '-'}</div>
      {!isStatistics && (
        <div className='dbl-table-compare-cell-value'>
          <MetricUpDown value={change} />
        </div>
      )}
    </div>
  );
};

// 对比日期单元格组件，判断渲染日期对比单元格还是指标对比单元格
const CompareCell: React.FC<IAliTableCellComponentProps> = (props) => {
  const { column } = props || {};
  const { isCompareDate } = column || {};
  if (isCompareDate) {
    return <CompareDateCell {...props} />;
  }
  return (<CompareMetricCell {...props} />);
};

export default CompareCell;